import { endOfDay, format, parse, startOfDay } from "date-fns";

import type { OptionItem } from "@/api/admin";

type DateRangeParams = {
  dateFrom?: string;
  dateTo?: string;
};

type DateRangeInput = string | OptionItem | undefined;

export const parseDateRangeToParams = (
  input?: DateRangeInput,
  isTimeZoneOffset: boolean = false
): DateRangeParams => {
  const rawValue = typeof input === "string" ? input : input?.name;

  if (!rawValue || !rawValue.includes(" - ")) {
    return {};
  }

  const [fromRaw, toRaw] = rawValue.split(" - ").map(v => v.trim());

  const fromDate = parse(fromRaw, "MMMM d, yyyy", new Date());
  const toDate = parse(toRaw, "MMMM d, yyyy", new Date());

  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
    return {};
  }

  const formatDate = isTimeZoneOffset
    ? "yyyy-MM-dd'T'HH:mm:ssxxx"
    : "yyyy-MM-dd'T'HH:mm:ss.SSS";

  return {
    dateFrom: format(startOfDay(fromDate), formatDate),
    dateTo: format(endOfDay(toDate), formatDate),
  };
};
